import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* updateLookbookOrder({ payload: { id, orderId, values, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.lookbooks.orders.update, pathParams: { id, orderId }, data: values });

    onSuccess && onSuccess();
    yield put(actions.updateLookbookOrderDone(data.result));
  } catch (error) {
    onError && onError();
    yield handleErrors({
      error,
      putErrorData: actions.updateLookbookOrderFailed,
      handledErrors,
      endpoint: api.lookbooks.orders.update.url
    });
  }
}

export const updateLookbookOrderSaga = takeEvery(types.UPDATE_LOOKBOOK_ORDER_REQUEST, updateLookbookOrder);